import { sanitize as sanitizeLink } from 'quill/formats/link';
import React from 'react';
import { useUIElementResize } from '../UIElementResizeContext';
import styles from './ImageNode.module.scss';

function sanitize(url: string) {
  return sanitizeLink(url, ['https', 'data']) ? url : '//:0';
}

export const ALT = 'User-uploaded Image';

interface ImageNodeProps {
  src: string;
  uploading: boolean;
  width?: number;
}

const ImageNode = ({ src, uploading, width }: ImageNodeProps) => {
  const onResize = useUIElementResize();

  const commonProps = {
    width,
    onLoad: onResize,
    onError: onResize,
    src: sanitize(src),
  };

  return uploading ? (
    <div className={styles.progressContainer}>
      <img className={styles.uploading} {...commonProps} alt={ALT} />
      <div className={styles.progress} />
    </div>
  ) : (
    <img {...commonProps} alt={ALT} />
  );
};

export default ImageNode;
